import React from 'react'
import classnames from 'classnames'

type Props = React.HTMLAttributes<HTMLHeadingElement>

export const FlowCardHeader: React.FC<Props> = ({
  children,
  className,
  ...rest
}) => {
  const classes = classnames('text-3xl leading-tight mb-4', className)
  return (
    <h3 className={classes} {...rest}>
      {children}
    </h3>
  )
}
